export enum NotificationPriority {
  LOW,
  NORMAL,
  HIGH,
}

export enum NotificationMedium {
  EMAIL,
  WEB,
}

export enum NotificationType {
  EMPLOYEE_BIRTHDAY = "EMPLOYEE_BIRTHDAY",
  EMPLOYEE_VISA_EXPIRING = "EMPLOYEE_VISA_EXPIRING",
  EMPLOYEE_CONTRACT_STARTING = "EMPLOYEE_CONTRACT_STARTING",
  EMPLOYEE_CONTRACT_ENDING = "EMPLOYEE_CONTRACT_ENDING",
  MANAGER_EMPLOYEE_BIRTHDAY = "MANAGER_EMPLOYEE_BIRTHDAY",
  CHANGE_REQUESTED = "CHANGE_REQUESTED",
  CHANGE_APPROVED = "CHANGE_APPROVED",
  CHANGE_REJECTED = "CHANGE_REJECTED",
  ABSENCE_REQUEST_REQUESTED = "ABSENCE_REQUEST_REQUESTED",
}

export interface NotificationDto {
  toUserUid: string;
  priority: NotificationPriority;
  type: NotificationType;
  medium: NotificationMedium;
  title: string;
  body: string;
  absenceRequestDuration?: number;
  absenceRequestIcon?: string;
  subjectFirstName?: string;
  subjectLastName?: string;
  subjectUserUid?: string;
  readOrSentAt?: string;
  creationDate?: string;
  toUserFirstName: string;
  toUserLastName: string;
  metadata?: Record<string, string | null>;
}
